<script setup>
  import FooterBannerAd from '@/components/FooterBannerAd.vue';

  function setFooterAdAttribute() {
    const body = document.documentElement;
    body.dataset.footerAd = true;
  }

  setFooterAdAttribute();
</script>

<template>
  <Teleport to=".map-container">
    <FooterBannerAd class="jwx-map__footer-banner-ad" />
  </Teleport>
</template>